import React from "react";
import styles from "./styles.module.scss";

export const SustainableGrowth = ({
  title = "Empowering sustainable growth",
  body = `
    <p>At Insight Recruitment, our mission is to Empower Sustainable Growth across industries that positively impact the world we live in.</p><br></br>
    <p>We believe in prioritising people and we work in partnership to connect the best talent with the most exciting companies in the industry, transforming the hiring process along the way.</p>
    <p>We have the desire to make a difference, to create long-term partnerships built upon trust, and deliver a quality service that consistently adds value.</p>
  `,
  cta = [{ label: "Learn More", link: "#", variant: "secondary" }],
  image,
  showGlow = true,
  className = "",
}) => {
  const button = cta?.[0];
  const isGradientVariant = className.includes("gradient-bg");
  const isLightTypography = className.includes("light-typography");

  let wrapperStyles = {};
  let innerStyles = {};
  if (isGradientVariant) {
    wrapperStyles.background = "none";
    innerStyles = {
      background: `
        linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%),
        url(/images/decorations/projects_decoration.svg),
        linear-gradient(180deg, #017550 0%, #006075 100%)
      `,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
    };
  }

  const titleStyles = isLightTypography
    ? {
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: "36px",
      }
    : {};

  const bodyStyles = isLightTypography
    ? {
        lineHeight: "normal",
      }
    : {};

  const ctaStyles = isLightTypography
    ? {
        background: "#fff",
        color: "#000",
      }
    : {};

  return (
    <section style={wrapperStyles} className={`${styles.wrapper} ${className}`} data-component="SustainableGrowth">
      <div className={styles.inner} style={innerStyles}>
        <div className={styles.imageCol}>
          {image?.url ? (
            <img src={image.url} alt="" className={styles.image} />
          ) : (
            <div className={styles.imagePlaceholder} aria-hidden="true" />
          )}
        </div>

        <div className={styles.contentCol}>
          <div className={styles.textGroup}>
            <h2 className={styles.title} style={titleStyles}>
              {title}
            </h2>
            <div className={styles.body} style={bodyStyles} dangerouslySetInnerHTML={{ __html: body }} />
          </div>

          {button?.label && (
            <a href={button.link} className={`button ${styles.cta}`} style={ctaStyles} aria-label={button.label}>
              <span>{button.label}</span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default SustainableGrowth;
